export enum TTSStrategy {
  ScreenReader = 'Screen Reader',
  WebSpeech = 'Web Speech',
}
